import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";

import { RunHistoryEntryType } from "../../types";

type CommentEntryProps = {
  username: string;
  body: string;
  createdAt: number;
};

const CommentEntry = ({ username, body, createdAt }: CommentEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Note</strong> added <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      state={RunHistoryEntryType.Comment}
      timestamp={createdAt}
      terminal
    >
      <HistoryEntryNote>
        <ReactMarkdown remarkPlugins={[gfm]} skipHtml>
          {body}
        </ReactMarkdown>
      </HistoryEntryNote>
    </HistoryEntryWrapper>
  );
};

export default CommentEntry;
